document.addEventListener("DOMContentLoaded", () => {
  const pageAanpakDiv = document.querySelector(".pageAanpak__row");
  if (!pageAanpakDiv) {
    console.log("Page does not have the class .pageAanpak. Script not executed.");
    return;
  }

  const sectionText = document.querySelector(".pageAanpak__textAppend");
  const appendHereParagraph = sectionText?.querySelector(".appendHere");
  const kvScoresParagraph = document.querySelector(".kvScores");

  if (!sectionText || !appendHereParagraph || !kvScoresParagraph) {
    console.error("One or more elements not found. Check your selectors.");
    return;
  }

  appendHereParagraph.insertAdjacentElement('afterend', kvScoresParagraph);
});
